import React from 'react';
import { Box, TextField, Button } from '@mui/material';

export interface OptionRowProps {
  value: string;
  points: number | '';
  index: number;
  onChange: (value: string) => void;
  onPointsChange: (value: number | '') => void;
  onCommitPoints: () => void;
  onRemove: () => void;
}

const OptionRow: React.FC<OptionRowProps> = React.memo(({ value, points, index, onChange, onPointsChange, onCommitPoints, onRemove }) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 140px auto' }, gap: 1, mb: 1 }}>
      <TextField
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={`Option ${index + 1}`}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } }}
      />
      <TextField
        type="text"
        label="Points"
        InputLabelProps={{ shrink: true }}
        value={points === undefined || points === null ? '' : points}
        onChange={(e) => {
          const raw = e.target.value;
          if (/^\d*$/.test(raw)) {
            onPointsChange(raw === '' ? '' : Number(raw));
          }
        }}
        onBlur={onCommitPoints}
        onWheel={(e) => { e.preventDefault(); }}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } }}
      />
      <Button color="error" onClick={onRemove}>Remove</Button>
    </Box>
  );
});

export default OptionRow;
